import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-gallery-block',
  templateUrl: './skeleton-gallery-block.component.html',
  styleUrls: ['./skeleton-gallery-block.component.scss']
})
export class SkeletonGalleryBlockComponent {
  public readonly skeletonCells = [1, 2, 3, 4, 5, 6];
}
